import React from 'react';
import { CubeMaker } from './cube-maker';
import { Euler } from 'three';
var distance = function (v1_x, v1_y, v2_x, v2_y) {
    return Math.hypot(v2_x - v1_x, v2_y - v1_y);
};
var midPoint = function (v1_x, v1_y, v2_x, v2_y) { return [
    (v2_x + v1_x) / 2,
    (v2_y + v1_y) / 2,
]; };
export var DoorThreeMaker = function (_a) {
    var meshRef = _a.meshRef, door = _a.door, height = _a.height, color = _a.color;
    var THICKNESS = 0.5;
    var ELEVATION = 0;
    var v1_x = door.v1_x, v1_y = door.v1_y, v2_x = door.v2_x, v2_y = door.v2_y;
    var angle = Math.atan2(v1_y - v2_y, v1_x - v2_x) - Math.PI / 2;
    var rot = new Euler(0, 0, angle);
    var pos = midPoint(v1_x, v1_y, v2_x, v2_y).concat(height / 2 + ELEVATION);
    var dist = distance(v1_x, v1_y, v2_x, v2_y);
    return (React.createElement(CubeMaker, { meshRef: meshRef, key: door.name, position: pos, size: [THICKNESS, dist, height], rot: rot, color: color }));
};
